import './style.scss';
import { Box, Typography } from '@mui/material';
import useState from '../../hooks/useState';
import { useCallback, useEffect } from 'react';
import TextField from '../TextField';
import Chip from '../Chip';
import StringHelper from '../../helpers/StringHelper';

interface ITagFieldProps {
    label?: string;
    name: string;
    value?: string[];
    handleChange?: (tags: string[]) => void;
    className?: string;
}

interface IStateValues {
    text: string;
    tags: string[];
}

const TagField: React.FC<ITagFieldProps> = ({
    label = undefined, 
    name, 
    value = [],
    handleChange = () => {},
    className = ''
}) => {
    const state = useState<IStateValues>({
        text: '',
        tags: value
    });


    useEffect(() => {
        handleChange(state.values.tags);
        // eslint-disable-next-line
    }, [state.values.tags]);


    const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
        const key = e.key.toLowerCase();

        if (key === 'tab') {
            e.preventDefault();
            handleUpdateText(`${state.values.text},`);
        }
        
        // eslint-disable-next-line
    }, [state.values.text]);


    const handleUpdateText = useCallback((text: string) => {
        text = text.toLowerCase();
        text = StringHelper.Normalize(text);
        state.update('text', text);

        if (text.match(/^[A-Za-z0-9]*$/)) {
            return;
        }

        const newTag = text.replace(/[\s~`!@#$%^&*(){}[\];:"'<,.>?/\\|_+=-]/g, '').trim();
        if (newTag.length === 0) {
            state.update('text', '');
            return;
        }
        
        const tagsAux = state.values.tags;
        if (tagsAux.includes(newTag)) {
            state.update('text', '');
            return;
        }

        tagsAux.push(newTag);
        state.update('tags', tagsAux);

        state.update('text', '');
        // eslint-disable-next-line
    }, [state.values]);


    return <Box className={`tagfield-default ${className}`}>
        {
            label && <Typography className='tagfield-default-title'>
                {label}
            </Typography>
        }

        <TextField 
            margin='none'
            value={state.values.text}
            onChange={e => handleUpdateText(e.target.value)}
            onKeyDown={e => handleKeyDown(e)}
            onBlur={() => handleUpdateText(`${state.values.text},`)}
            className='container-embedded tagfield-default-input'
            required={false}
        />

        <Box className={`tagfield-default-container-tags ${state.values.tags.length === 0 ? 'empty' : ''}`}>
            {
                state.values.tags.map((tag, index) => {
                    return <>
                        <Chip 
                            label={tag} 
                            key={`tagfield_chip_${index}`} 
                            hoverAction='remove'
                            onClick={() => {
                                const tagsAux = state.values.tags;
                                tagsAux.splice(index, 1);
                                state.update('tags', tagsAux);
                            }}
                        />

                        <input 
                            name={`${name}[${index}]`} 
                            value={tag} 
                            className='tagfield-default-container-tags-input' 
                            key={`tagfield_chipinput_${index}`} 
                        />
                    </>
                })
            }
        </Box>
    </Box>;
}

export default TagField;